import { useToastStore } from '../../stores/toast.store'

const ICON = { success: '✓', error: '✕', info: 'ℹ' }
const BG   = {
  success: 'bg-[#1B6B3A] text-white',
  error:   'bg-red-600 text-white',
  info:    'bg-gray-800 text-white',
}

export default function Toaster() {
  const { toasts, dismiss } = useToastStore()
  if (!toasts.length) return null

  return (
    <div className="fixed bottom-5 right-5 z-[9999] flex flex-col gap-2 pointer-events-none">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`flex items-center gap-2.5 px-4 py-3 rounded-xl shadow-lg text-sm font-medium max-w-xs pointer-events-auto animate-slide-up ${BG[t.type]}`}
        >
          <span className="text-base leading-none">{ICON[t.type]}</span>
          <span className="flex-1">{t.message}</span>
          <button
            onClick={() => dismiss(t.id)}
            className="opacity-60 hover:opacity-100 text-lg leading-none ml-1"
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  )
}
